import { Badge, Flex, Tooltip } from '@optiaxiom/react';

type ProductsCellProps = {
  products: string[];
};

export const ProductsCell = ({ products }: ProductsCellProps) => {
  if (products.length === 0) {
    return null;
  }

  return (
    <Tooltip content={products.join(', ')}>
      <Flex gap="4" flexDirection="row" alignItems="center" flexWrap="wrap">
        {products.slice(0, 2).map(product_sku => (
          <Badge variant="subtle" intent="information" key={product_sku}>
            {product_sku}
          </Badge>
        ))}
        {products.length > 2 && (
          <Badge variant="subtle" intent="neutral">
            +{products.length - 2}
          </Badge>
        )}
      </Flex>
    </Tooltip>
  );
};
